@let showsSelected = challenge().isSelected || previewSelected();
@let showsUnselection = challenge().canBeUnselected(phase());
@let showsFooter = showsSelected && challenge().progress < challenge().target;

<div class="card" [id]="challenge().offerId">
  <div
    class="card-header"
    role="img"
    [title]="config().header.backgroundImage.bannerAriaLabel"
    [attr.aria-label]="config().header.backgroundImage.bannerAriaLabel"
    [style.backgroundImage]="config().header.backgroundImage.url | transformUrl"
  >
    <div class="promise-container">
      <p
        class="visits-label"
        [style]="{
          color: config().body.visitsLabel.color,
          fontFamily: config().body.visitsLabel.fontFamily,
        }"
        [innerHTML]="
          config().body.visitsLabel.text
            | replaceVars: challenge().target
            | safe
        "
      ></p>
      <p
        class="reward-label"
        [style]="{
          color: config().body.rewardLabel.color,
          fontFamily: config().body.rewardLabel.fontFamily,
        }"
        [innerHTML]="
          config().body.rewardLabel.text
            | replaceVars: challenge().rewardRatio : true
            | safe
        "
      ></p>
    </div>
  </div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        [style]="{
          color: labelConfig.color,
          fontFamily: labelConfig.fontFamily,
        }"
      >
        {{
          labelConfig.label | replaceVars: challenge().minAmountByTransaction
        }}
      </p>
    }
  </div>

  <div
    class="card-content"
    data-cy="frequency-card-content"
    [class.has-selection]="!showsSelected"
    [class.has-footer]="showsFooter"
  >
    @if (showsSelected && challenge().progress < challenge().target) {
      <div class="card-body" data-cy="frequency-card-content">
        <p
          class="first-label"
          [style]="{
            color: config().body.firstLabel.color,
            fontFamily: config().body.firstLabel.fontFamily,
          }"
          [innerHTML]="
            config().body.firstLabel.text
              | replaceVars: challenge().target
              | safe
          "
        ></p>

        <!-- Steps <= 5 -->
        @let steps = challenge().steps;
        @if (steps.length <= 5) {
          <div class="items" data-cy="stamps">
            @for (item of steps; track $index) {
              <div class="item">
                <img
                  [alt]="
                    item <= challenge().progress
                      ? config().body.stamps.iconSelectedAlternativeText
                      : config().body.stamps.iconNonSelectedAlternativeText
                  "
                  data-cy="stamp"
                  class="responsive-width"
                  [src]="
                    item <= challenge().progress
                      ? config().body.stamps.iconSelected
                      : config().body.stamps.iconNonSelected
                  "
                />
                @if (config().body.stamps.showNumbers) {
                  <span
                    class="number"
                    [class.active]="item <= challenge().progress"
                  >
                    {{ item }}
                  </span>
                }
              </div>
            }
          </div>
        }

        <!-- Steps > 5 -->
        @if (steps.length > 5) {
          <div class="visits-container">
            <p class="number" data-cy="progress">{{ challenge().progress }}</p>
            <span class="sign">/</span>
            <p
              class="number total"
              data-cy="target"
              [style]="{
                backgroundColor: config().body.totalBg,
              }"
            >
              {{ challenge().target }}
            </p>
            <p class="label">visits</p>
          </div>
        }
      </div>
    }

    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }

    <!-- Selection Button -->
    @if (!showsSelected) {
      <div class="selection-section">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }

    @if (showsFooter) {
      <div class="footer">
        @if (showsUnselection) {
          <b2c-unselection-button
            [phase]="phase()"
            [challenge]="challenge()"
            [isEventChallenge]="isEventChallenge()"
          />
        }
        @let remainingVisitsLabel = config().footer.remainingVisitsLabel;
        <p
          class="remaining-visits"
          data-cy="remaining_visits"
          [style.color]="remainingVisitsLabel.color"
          [style.fontFamily]="remainingVisitsLabel.fontFamily"
          [innerHTML]="
            remainingVisitsLabel.text | replaceVars: remainingVisits() | safe
          "
        ></p>
      </div>
    }
  </div>
</div>
